<template>
  <BackDrop @close-backdrop="close">
    <template v-slot:header>
      <h2>{{ $t("howToPlayBackDrop.title") }}</h2>
    </template>
    <template v-slot:main>
      <section style="margin-top: 10%">
        <div class="space-evenly" style="margin-bottom: 20px">
          <button
            class="btn btn-base btn-fill btn"
            @click="selectGame('wheel')"
          >
            {{ $t("home.wheelButton") }}
          </button>
          <button class="btn btn-base btn-fill" @click="selectGame('lottery')">
            {{ $t("home.lotteryButton") }}
          </button>
        </div>

        <div class="space-evenly" style="margin-bottom: 20px">
          <button
            v-if="linguaPortuguesa"
            class="btn btn-base btn-fill"
            @click="selectGame('neverHave')"
          >
            {{ $t("home.neverHaveButton") }}
          </button>
          <button
            class="btn btn-base btn-fill"
            @click="selectGame('badPicker')"
          >
            {{ $t("home.fingerSelectorButton") }}
          </button>
        </div>

        <div class="space-evenly" style="margin-bottom: 20px">
          <button
            class="btn btn-base btn-fill"
            @click="selectGame('whereIsIt')"
          >
            {{ $t("home.whereIsItButton") }}
          </button>

          <button class="btn btn-base btn-fill" @click="selectGame('simon')">
            {{ $t("home.simonButton") }}
          </button>
        </div>

        <div
          class="space-evenly"
          v-if="!linguaPortuguesa"
          style="margin-bottom: 20px"
        >
          <button
            class="btn btn-base btn-fill"
            @click="selectGame('truthOrDrink')"
          >
            {{ $t("home.truthOrDrink") }}
          </button>
        </div>
      </section>
      <section style="color: white">
        <h5 class="tip">{{ tip }}</h5>
      </section>
    </template>
  </BackDrop>
</template>

<script>
import { mixin } from "src/mixin";
import BackDrop from "src/components/BackDrop/BackDrop.vue";

export default {
  name: "MainGamesBackdrop",

  mixins: [mixin],

  components: {
    BackDrop,
  },

  data() {
    return {
      game: "",
      tip: "Selecione um jogo",
    };
  },
  methods: {
    close() {
      this.$emit("close-backdrop");
    },
    selectGame(game) {
      this.game = game;
      this.tip = this.$t(`howToPlayBackDrop.tips.${game}`);
      this.$emit("select-game", game);
    },
  },
};
</script>

<style>
.space-evenly {
  display: flex;
  justify-content: space-evenly;
}

.tip {
  text-align: center;
  font-weight: 400;
  margin: 0px 30px;
}
</style>
